import React from "react";
import { useTiendaConfig } from "../../../hooks/useTiendaConfig";

function WhatsAppButton() {
    const { whatsappLink } = useTiendaConfig();

    const getWhatsappUrl = () => {
        if (whatsappLink && typeof whatsappLink.url === 'string' && whatsappLink.url.trim() !== '') {
            return whatsappLink.url;
        }
        return '#';
    };

    return (
        <>
            <a
                href={getWhatsappUrl()}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                    position: "fixed",
                    bottom: "20px",
                    right: "20px",
                    zIndex: 999,
                    background: "#25D366",
                    borderRadius: "50%",
                    width: "55px",
                    height: "55px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0 6px 15px rgba(0,0,0,0.2)",
                    transition: "transform 0.2s ease"
                }}
                onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.1)"}
                onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="26"
                    height="26"
                    fill="#fff"
                    viewBox="0 0 16 16"
                >
                    <path d="M13.601 2.326A7.85 7.85 0 0 0 8.007 0C3.589 0 .002 3.587 0 8.007a7.96 7.96 0 0 0 1.1 4.02L0 16l4.082-1.066a7.94 7.94 0 0 0 3.925 1.002h.003c4.418 0 8.005-3.587 8.007-8.007a7.85 7.85 0 0 0-2.416-5.603zM8.01 14.54a6.52 6.52 0 0 1-3.316-.907l-.238-.14-2.422.633.647-2.361-.154-.243a6.48 6.48 0 0 1-.997-3.514c.002-3.592 2.92-6.51 6.513-6.51a6.46 6.46 0 0 1 4.605 1.905 6.46 6.46 0 0 1 1.906 4.605c-.002 3.592-2.92 6.51-6.514 6.51zm3.58-4.864c-.196-.098-1.157-.57-1.337-.635-.18-.066-.31-.098-.44.098-.13.196-.505.635-.619.766-.114.13-.228.147-.424.049-.196-.098-.828-.305-1.577-.973-.582-.52-.975-1.162-1.09-1.358-.114-.196-.012-.302.086-.4.088-.087.196-.228.294-.342.098-.114.13-.196.196-.327.065-.13.033-.245-.016-.343-.049-.098-.44-1.06-.602-1.45-.158-.379-.319-.327-.44-.333-.114-.006-.245-.007-.376-.007-.13 0-.343.049-.522.245-.18.196-.686.67-.686 1.634 0 .964.702 1.895.8 2.025.098.13 1.382 2.11 3.35 2.957.469.202.835.323 1.12.414.47.15.897.129 1.235.078.377-.056 1.157-.473 1.321-.93.163-.457.163-.848.114-.93-.049-.082-.18-.13-.376-.228z" />
                </svg>
            </a>
        </>
    )
}

export default WhatsAppButton;  